<template>
  <div class="menu-management">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         菜单管理
       </h4>
     </template>
    <el-row :gutter="10">
      <el-col :sm="14" :xs="24">
        <menus
          @menuClick="menuClick"
          @resetPermission="resetPermission"
        ></menus>
      </el-col>
      <el-col :sm="10" :xs="24">
        <permission ref="routePermission" type="1"></permission>
        <permission ref="buttonPermission" type="2"></permission>
      </el-col>
    </el-row>
  </div>
</template> 

<script>
import Menus from "./menucomponents/Menu.vue";
import Permission from "./menucomponents/Permission.vue";
export default {
  name: "Menu-management",
  components: { Menus, Permission },
  data() {
    return {};
  },
  methods: {
    menuClick(row) {
      this.$refs.routePermission.menuClick(row);
      this.$refs.buttonPermission.menuClick(row);
    },
    resetPermission() {
      this.menuName = undefined;
      this.$refs.routePermission.resetPermission();
      this.$refs.buttonPermission.resetPermission();
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/sysmenu/menu-management.vue